<div
  id="issue-count-totals"
  [ngbPopover]="highPriorityTotalPopover"
  placement="top-right"
  autoClose="outside"
  container="body"
>
  <span class="mdi mdi-alert-circle text-danger"></span
  ><span>{{ totalHighFound }}</span>
  <span class="mdi mdi-clock-outline text-danger ml-1"></span
  ><span>{{ totalHighWaiting }}</span>
  <span class="mdi mdi-alert-circle text-warning ml-1"></span
  ><span>{{ totalMediumFound }}</span>
  <span class="mdi mdi-clock-outline text-warning ml-1"></span
  ><span>{{ totalMediumWaiting }}</span>
</div>

<ng-template #highPriorityTotalPopover>
  <table
    nf-table
    [hover]="true"
    aria-describedby="Issue Count Summaries By Category"
  >
    <thead>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">
          <span class="mdi mdi-alert-circle text-danger"></span>
        </th>
        <th scope="col">
          <span class="mdi mdi-clock-outline text-danger"></span>
        </th>
        <th scope="col">
          <span class="mdi mdi-alert-circle text-warning"></span>
        </th>
        <th scope="col">
          <span class="mdi mdi-clock-outline text-warning"></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of issueCountRows">
        <td>{{ row.category }}</td>
        <td>{{ row.highFound }}</td>
        <td>{{ row.highWaiting }}</td>
        <td>{{ row.mediumFound }}</td>
        <td>{{ row.mediumWaiting }}</td>
      </tr>
    </tbody>
  </table>
</ng-template>
